import JsBridge, { waitForJsBridge } from "@/utils/jsBridge";
import store from "store";
import { getBrowser } from "@/utils/browser";
import { parseAppBridgeDomainResponse, isAppDomainConfigBridgeSupported, MIN_APP_DOMAIN_CONFIG_BRIDGE_VERSION } from "@/utils/apiHost";
const browser = getBrowser();

export function jumpLink(data: any) {
  let params = {};
  if (typeof data === "string") {
    params = {
      url: data
    };
  } else if (Object.prototype.toString.call(data) === "[object Object]") {
    params = data;
  }
  JsBridge.callHandler("jumpPage", { type: 2, ...params });
}

export function login(params) {
  JsBridge.callHandler("login", params, res => {
    
  });
}

export function getAppToken() {
  return new Promise(resolve => {
    if (browser.isApp) {
      if (browser.isGetProApp) {
        resolve("isGetPro");
      } else {
        JsBridge.callHandler("getUserInfo", "", (res: any) => {
          const { token, userInfo, accountStatus } = JSON.parse(res);

          if (token) {
            sessionStorage.setItem("token", token);
            localStorage.setItem("token", token);
          }
          store.set("userInfo", userInfo);
          store.set("accountStatus", accountStatus || 0);
          resolve(res);
        });
      }
    } else {
      resolve();
    }
  });
}

export function setStatementDetailInfo(params) {
  JsBridge.callHandler("setStatementDetailInfo", params);
}

export function goBack(params = "") {
  JsBridge.callHandler("goBack", params);
}

export function closeWebView(params = "") {
  JsBridge.callHandler("closeWebView", params);
}

export function pageBusProviderShut(params = {}) {
  JsBridge.callHandler("pageBusProviderShut", params);
}

export function showQuickVerification(params = {}, callback?: Function) {
  JsBridge.callHandler("showQuickVerification", params, callback);
}

export function webViewRightButton(params = {}) {
  JsBridge.callHandler("webViewRightButton", params);
}

export function webViewHeaderRightIcons(params: { showSearch?: boolean; showMessage?: boolean } = {}) {
  if (browser.isApp) {
    JsBridge.callHandler("webViewHeaderRightIcons", JSON.stringify(params));
  }
}

export function showWebView(params = '') {
  JsBridge.callHandler("showWebView", params);
}

export function changeAccountType(params = '') {
  JsBridge.callHandler("changeAccountType", params);
}

export function dialogStatus(params = {}) {
  JsBridge.callHandler("dialogStatus", params);
}


export function closeDialog(params = {}, callback?: Function) {
  JsBridge.callHandler("closeDialog", params);
}

export function setStorageApp(key: string, value: {}) {
  const data = {};
  data[key] = value;
  if (getBrowser().isApp) {
    JsBridge.callHandler("setStorage", JSON.stringify(data));
  } else {
    localStorage.setItem(key, JSON.stringify(value));
  }
}

export function getStorageApp(key: string, cb) {
  if (getBrowser().isApp) {
    JsBridge.callHandler("getStorage", key, e => {
      if(e){
        cb(JSON.parse(e));
      }else{
        cb("");
      }
    });
  } else {
    const data: string | null = localStorage.getItem(key);
    if(!data){
      cb("");
    }else{
      cb(JSON.parse(typeof data === "string" ? data : "{}"));
    }

  }
}

export function getRequestHeaderApp() {
  return new Promise((resolve, reject) => {
    let timer: any;
    JsBridge.callHandler("getRequestHeader", "", (res) => {
      if(res){
        res = JSON.parse(res);
      }
      clearTimeout(timer);
      resolve(res);
    });
    // 此处app端无 异常通知，前端手动抛出异常
    timer = setTimeout(()=>{
      reject();
      clearTimeout(timer);
    },500);
  })
}

/** App 当前域名配置：getCurrentDomainConfig，与 OSS 一致可为 { AppConfig:{api,ws} } 或 { api, ws } */
export function getCurrentDomainConfig(): Promise<Record<string, any> | null> {
  const env = getBrowser();
  if (!env.isApp) {
    return Promise.resolve(null);
  }

  if (!isAppDomainConfigBridgeSupported(env.appVersion)) {
    console.log(
      `[域名配置] App ${env.appVersion || "未知版本"} < ${MIN_APP_DOMAIN_CONFIG_BRIDGE_VERSION}，跳过 getCurrentDomainConfig，走 UA/config.js 兜底`
    );
    return Promise.resolve(null);
  }

  const bridgeWait =
    (window as any).WebViewJavascriptBridge != null
      ? Promise.resolve(true)
      : waitForJsBridge();

  return bridgeWait.then(bridgeReady => {
    if (!bridgeReady) {
      console.log(
        "[域名配置] WebViewJavascriptBridge 未在超时内就绪，仍将尝试 getCurrentDomainConfig"
      );
    }

    return new Promise<Record<string, any> | null>(resolve => {
      let settled = false;
      let timer: ReturnType<typeof setTimeout>;
      const finish = (value: Record<string, any> | null) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      };

      console.log("[域名配置] 调用 JsBridge.getCurrentDomainConfig");

      JsBridge.callHandler("getCurrentDomainConfig", "", (res: any) => {
        try {
          const data = parseAppBridgeDomainResponse(res);
          console.log("[域名配置] getCurrentDomainConfig 回调", res, "解析后", data);
          finish(data);
        } catch (e) {
          console.log("[域名配置] getCurrentDomainConfig 解析失败", res, e);
          finish(null);
        }
      });
      timer = setTimeout(() => {
        console.log("[域名配置] getCurrentDomainConfig 超时(8s)无回调");
        finish(null);
      }, 8000);
    });
  });
}
